import { Navigate, useParams } from "react-router-dom";
import { ROUTES } from "@/config/constants";

/** Redireciona URLs antigas do relatório para a unidade com modal aberto. */
export function ChaoDeObraReportPage() {
  const { unitId: unitIdParam, reportId: reportIdParam } = useParams<{
    unitId: string;
    reportId: string;
  }>();
  const unitId = unitIdParam ? decodeURIComponent(unitIdParam) : "";
  const reportId = reportIdParam ? decodeURIComponent(reportIdParam) : "";

  if (!unitId || !reportId) {
    return <Navigate to={ROUTES.CHAO_DE_OBRA} replace />;
  }

  const qs = new URLSearchParams({ relatorio: reportId });
  return (
    <Navigate
      to={`${ROUTES.CHAO_DE_OBRA}/unidade/${encodeURIComponent(unitId)}?${qs.toString()}`}
      replace
    />
  );
}
